export let versionInfo: VersionInfo;

/**
 * Obsahuje informace o konkrétní verzi aplikace
 */
export interface VersionInfo {
    client: { version: string; configuration: string; buildTime: string; buildAuthor: string; changeSet: string; changeSetDate: string };
    server: { versionId: string };
}
